import React from "react";
import { Link } from "react-router-dom";
import * as DateHelper from "../utils/date.formatter";
import { REACT_APP_MODE } from "../config";
import { Translation } from "react-i18next";
import i18n from "../languages/lang.js";

export default props => {
  if (!props.data || props.data.length === 0) {
    return <div className="empty-data">{i18n.t("system.empty_data")}</div>;
  }
  return (
    <Translation>
      {t => (
        <table className="table-list-simple">
          <thead>
            <tr>
              <th>{t("common.time")}</th>
              <th>{t("common.location")}</th>
              <th className="last">{t("common.distance")}</th>
            </tr>
          </thead>
          <tbody>
            {props.data.map(item => {
              return (
                <tr
                  key={item.event}
                  className={`${item.distance > 1 ? "distance-alert" : ""}`}
                >
                  <td>
                    <Link to={`/events/${item.event}`}>
                      {DateHelper.toLocalString(item.time)}
                    </Link>
                  </td>
                  <td>
                    <Link to={`/events/${item.event}`}>
                      {`lon:${item.value.longitude}, lat:${item.value.latitude}`}
                    </Link>
                  </td>
                  <td className={`last`}>
                    <Link to={`/events/${item.event}`}>
                      {item.distance || 0} km
                    </Link>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </Translation>
  );
};
